<template>
	<div>
		<div class="afterSale_container">
			<p class="sub_menu_title">安装售后</p>
			<div class="afterSale_list">
				<div class="afterSale_box">
					<div class="afterSale_detail">
						<p class="afterSale_title">技术保障</p>
						<p class="afterSale_msg">
							项目实施前,由科颐轩工程师对场地进行现场勘查并收集用户意见,制定初步安装方案并召开双方项目启动会明确双方责任与义务。在项目实施过程中,公司的产品在检验合格后方投入使用;工程师严格遵守公司规章制度,保护实验室贵重仪器的安全、科学管理,做好施工现场的各项管理工作。
						</p>
					</div>
					<img class="afterSale_img" src="../../assets/static/images/j1.png">
				</div>
				<div class="afterSale_box_r">
					<div class="afterSale_detail">
						<p class="afterSale_title">流程规范</p>
						<p class="afterSale_msg">
							系统本身的稳定性保证极低的出错率;并且在出现故障时有完善处理机制能够保证不影响仪器的正常使用,不影响实验室科研工作正常进行。在此基础上对相关系统管理员进行完善培训,在出现常规问题时能够轻松解决。提供客户培训,包括管理员、全员用户,提供后台调阅、查询,前台操作等,包括现场培训、视频培训、课件培训等。
						</p>
					</div>
					<img style="left: 0;" class="afterSale_img" src="../../assets/static/images/j2.png">
				</div>
				<div class="afterSale_box">
					<div class="afterSale_detail">
						<p class="afterSale_title" style="margin: 0.75rem 0;">质保体系</p>
						<p class="afterSale_msg">
							提供原厂服务及本地化售后服务网点维护,提供硬件两年、软件三年的质保期,质保期间自主研发的硬件损坏只换不修①软件的故障问题,通过远程网络在线维护,即时响应;设备故障报修的响应时间为2小时,手机7*24小时在线若电话中无法解决,接到报障电话24小时内派工程技术人员上门维修,在检修8小时后仍无法排除,在48小时内提供不低于故障设备规格型号档次的备用设备进行更换,直至故障设备修复。②7*24小时售后服务热线:400-880-8582③QQ、微信在线,保障碎片化时间的响应服务,保障随时咨询或留言,为阳供多种的方式选择
						</p>
					</div>
					<img class="afterSale_img" src="../../assets/static/images/j3.png">
				</div>
			</div>
		</div>
		<div class="routine_container">
			<p class="sub_menu_title">常规产品列表</p>
			<div class="routine_top">
				<p style="left: 2.6rem;">序号</p>
				<p style="left: 12.6rem;">名称</p>
				<p style="left: 23.6rem;">产品/服务名称</p>
				<p style="left: 43rem;">类别</p>
				<p style="right: 11rem;">描述</p>
			</div>
			<div class="routine_table">
				<div class="routine_tr">
					<div>
						<p class="num_title">1</p>
					</div>

					<div>
						<p class="name_title">仪器管理系统</p>
					</div>
					<div class="service_goods_title">
						<p>系统软件</p>
						<p>仪器智能控制器</p>
						<p>短信、邮件</p>
					</div>
					<div class="type_title">
						<p>软件</p>
						<p>硬件</p>
						<p>第三方服务</p>
					</div>
					<div class="describe_title">
						<p>人员管理、培训考核、仪器管理实验耗材管理、信息公告、数据统计</p>
						<p style="margin-top: -0.5rem;">①安卓智能人脸识别版;②安卓智能常规版;④常规版</p>
						<p style="margin-top: -1.2rem;">标配免费1万条短信、2年企业邮箱服务</p>
					</div>
				</div>
				<div class="routine_tr bg">
					<div>
						<p class="num_title">2</p>
					</div>

					<div>
						<p class="name_title">实验室安全系统</p>
					</div>
					<div class="service_goods_title">
						<p>系统软件</p>
						<p>门禁智能控制器</p>
						<p>视频监控子系统</p>
						<p>环境温湿度监测器</p>
						<p>气体监测器</p>
					</div>
					<div class="type_title">
						<p>软件</p>
						<p>硬件</p>
						<p>软硬件</p>
						<p>硬件</p>
						<p>硬件</p>
					</div>
					<div class="describe_title">
						<p>门禁管理、视频监控、安全查询、环境监测</p>
						<p>①安卓智能人脸识别版;②常规版</p>
						<p>市场知名品牌产品,可选摄像头、信号传输线路设计录像存储及视频上墙(监控中心)等不同需求</p>
						<p>温湿度探测及数据传输,异常报警推送</p>
						<p>气体浓度监测及数据传输,异常报警推送</p>
					</div>
				</div>
				<div class="routine_tr">
					<div>
						<p class="num_title">3</p>
					</div>

					<div>
						<p class="name_title">共享支持系统</p>
					</div>
					<div class="service_goods_title">
						<p>系统软件</p>
						<p>冰箱智能控制器</p>
						<p>纯水仪智能控制器</p>
						<p>智能储物柜</p>
					</div>
					<div class="type_title">
						<p>软件</p>
						<p>硬件</p>
						<p>第三方服务</p>
						<p>硬件</p>
					</div>
					<div class="describe_title">
						<p>科研共享平台对接，超低温冰箱管控、纯水仪管控智能储物柜管理、信息发布管理</p>
						<p>刷卡/二维码鉴权，记录开关门时间；冰箱温度监测</p>
						<p style="margin-top: -0.8rem;">刷卡/二维码鉴权，记录开关门时间、统计时间</p>
						<p>刷卡鉴权，按需定制8门、 10门、 12门等多种规格</p>
					</div>
				</div>
				<div class="routine_tr bg">
					<div>
						<p class="num_title">4</p>
					</div>

					<div>
						<p class="name_title">危化品管理系统</p>
					</div>
					<div class="service_goods_title">
						<p>系统软件</p>
						<p>危化品智能管理柜</p>
						<p>智能中控台</p>
					</div>
					<div class="type_title">
						<p>软件</p>
						<p>硬件</p>
						<p>硬件</p>
					</div>
					<div class="describe_title">
						<p>危化品仓库管理、实验室领用、危化品使用管理</p>
						<p>支持双人双锁;赋码入库,双层防火构造按需定制45加仑、60加仑、90加仑等多种规格</p>
						<p style="margin-top: -0.7rem;">包含探测及传输模块,精准度高,可测范围广</p>
					</div>
				</div>
				<div class="routine_tr">
					<div>
						<p class="num_title">5</p>
					</div>

					<div>
						<p class="name_title">动物房管理系</p>
					</div>
					<div class="service_goods_title">
						<p>系统软件</p>
						<p>智能手持PDA</p>
						<p>平板电脑</p>
					</div>
					<div class="type_title">
						<p>软件</p>
						<p>硬件</p>
						<p>硬件</p>
					</div>
					<div class="describe_title">
						<p style="margin: 0;padding: 0;">人员培训、伦理管理、实验管理；</p>
						<p >寄养管理、动物生产、费用管理</p>
						<p>安卓操作系统,WI-FI/4G网络连接;刷卡鉴权登录,笼位标签识别;笼卡信息记录</p>
						<p style="margin-top: -1rem;">安卓操作系统,WI-FI/4G网络连接;刷卡鉴权登录,笼位标签识别;笼卡信息记录</p>
					</div>
				</div>
				<div class="routine_tr bg">
					<div>
						<p class="num_title">6</p>
					</div>

					<div>
						<p class="name_title">移动端功能</p>
					</div>
					<div class="service_goods_title">
						<p>移动端</p>

					</div>
					<div class="type_title">

						<p>软件</p>

					</div>
					<div class="describe_title">
						<p>仪器预约、预约审核推送、远程开关机、预警信息推送</p>

					</div>
				</div>
				<div class="routine_tr">
					<div>
						<p class="num_title">7</p>
					</div>

					<div>
						<p class="name_title">配件产品</p>
					</div>
					<div class="service_goods_title">
						<p>服务器</p>
						<p>AP、AC</p>
						<p>线管/槽等</p>
					</div>
					<div class="type_title">
						<p>软件</p>
						<p>硬件</p>
						<p>硬件</p>
					</div>
					<div class="describe_title">
						<p style="margin: 0;padding: 0;">人员培训、伦理管理、实验管理；</p>
						<p>寄养管理、动物生产、费用管理</p>
						<p style="margin-top: -0.8rem;">企业级知名品牌</p>
						<p>电线、网线、管槽、发卡器、IC/ID卡</p>
					</div>
				</div>
				<div class="routine_tr bg">
					<div>
						<p class="num_title">8</p>
					</div>

					<div>
						<p class="name_title">培训</p>
					</div>
					<div class="service_goods_title">
						<p>培训</p>
						<p>管理制度资讯</p>
						<p>维保</p>
						<p>科研共享平台对接</p>
					</div>
					<div class="type_title">
						<p>服务</p>
						<p>服务</p>
						<p>服务</p>
						<p>服务</p>
					</div>
					<div class="describe_title" style="margin-top: -1.5rem;">
						<p>相关人员培训培训服务400服务热线、微信、QQ、邮件通讯工具支持</p>
						<p style="margin-top: -1rem;">入室培训服务、共享使用规范、岗位设定8售后服务管理制度咨询服务管理人员的职责和权限设定、违规惩罚制度等</p>
						<p >硬件2年保修、软件3年维护</p>
						<p>包含探测及传输模块,精准度高,可测范围广</p>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import { scrollAnimation } from '../../utils/js/scrollAnimation.js';
	export default {
		created(){
			const currentY = document.documentElement.scrollTop || document.body.scrollTop
			scrollAnimation(currentY, 800)
		},
	}
</script>

<style lang="less" scoped>
	.afterSale_container {
		margin: 2rem 0;

		.afterSale_list {
			width: 75rem;
			margin: 0 auto;
			background-color: #F9FAFC;
			display: flex;
			flex-direction: column;
			justify-content: space-between;
		}

		.afterSale_img {
			position: absolute;
			width: 24.9375rem;
			height: 11.8125rem;
			right: 0;
			top: 0;
		}

		.afterSale_box {
			width: 75rem;
			height: 11.8125rem;
			position: relative;
			display: flex;
			flex-direction: column;
			justify-content: center;
			align-items: flex-start;
			padding: 0 3.2rem;
		}

		.afterSale_box_r {
			width: 75rem;
			height: 11.8125rem;
			position: relative;
			display: flex;
			flex-direction: column;
			justify-content: center;
			align-items: flex-end;
			padding-right: 2rem;
		}

		.afterSale_title {
			font-size: 1.25rem;
			font-family: PingFangSC-Regular, PingFang SC;
			font-weight: 400;
			color: #333333;

		}

		.afterSale_msg {
			font-size: 0.9375rem;
			font-family: PingFangSC-Regular, PingFang SC;
			font-weight: 400;
			color: #666666;
		}

		.afterSale_detail {
			width: 43.8125rem;
		}
	}
	.routine_container{
		.routine_table {
			.routine_tr {
				width: 75rem;
				margin: 0 auto;
				display: flex;
				justify-content: space-around;
				align-items: center;
				flex-wrap: nowrap;
				// padding: 1.4rem 0;
			}
		
			.name_title {
				font-size: 1.125rem;
				font-family: PingFangSC-Regular, PingFang SC;
				font-weight: 400;
				color: #333333;
				width: 8.75rem;
				text-align: center;
				
			}
		
			.num_title {
				font-size: 1.125rem;
				font-family: PingFangSC-Regular, PingFang SC;
				font-weight: 400;
				color: #333333;
				width:5rem;
				text-align: center;
				
			}
		
			.service_goods_title {
				font-size: 0.9375rem;
				font-family: PingFangSC-Regular, PingFang SC;
				font-weight: 400;
				color: #333333;
				width: 18%;
				text-align: center;
			}
			.service_goods_title p{
				padding: 1rem 0;
				
			}
			.type_title p{
				padding: 1rem 0;
			}
			.describe_title p{
				padding: 0.8rem 0;
				}
			.type_title {
				font-size: 0.9375rem;
				font-family: PingFangSC-Regular, PingFang SC;
				font-weight: 400;
				color: #333333;
				width: 18%;
				text-align: center;
				padding: 2rem 0;
			}
		
			.describe_title {
				font-size: 0.9375rem;
				font-family: PingFangSC-Regular, PingFang SC;
				font-weight: 400;
				color: #333333;
				width: 19.6875rem;
				padding: 2rem 0;
				
			}
			.bg{
				background-color:  #F9FAFC;
			}
			
		}
		.routine_top{
			width: 75rem;
			height: 6.75rem;
			margin: 0 auto;
			background: #3273FA;
			display: flex;
			position: relative;
			align-items: center;
			
		}
		.routine_top p{
			font-size: 1.25rem;
			font-family: PingFang-SC-Bold, PingFang-SC;
			font-weight: bold;
			color: #FFFFFF;
			position: absolute;
			
		}
	}
	
</style>
